import { render } from "./Rank.vue?vue&type=template&id=04e402be"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/index/components/Rank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04e402be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04e402be', __exports__)) {
    console.log('reload')
    api.reload('04e402be', __exports__)
  }
  
  module.hot.accept("./Rank.vue?vue&type=template&id=04e402be", () => {
    console.log('re-render')
    api.rerender('04e402be', render)
  })

}


export default __exports__